<template>
  <auth-x-widget
    ref="widget"
    :preview-mode="false"
    :loading.sync="loading"
    :widget-data="widgetData"
    :domain-data="domainData"
    :field-types="fieldTypes"
    :social-auth="true"
    :user-data="userData"
  />
</template>

<script>
import { fieldTypes } from "@/lib/utils";
import AuthXWidget from "@/components/Products/AuthX/Widget/AuthXWidget";

export default {
  name: "VendorLoginProcessingT",

  components: {
    AuthXWidget
  },

  data() {
    return {
      loading: true,
      sessionExpired: false,
      appCode: "",
      sessionToken: "",
      appData: {},
      widgetData: {},
      domainData: {
        appCode: "",
        referer: "",
        refererRedirectUrl: ""
      },
      userData: {},
      fieldTypes: {}
    };
  },

  created() {
    this.sessionToken = localStorage["vendor-session-token"];
    this.processSocialAuthentication();
  },

  methods: {
    processSocialAuthentication() {
      const socialType = localStorage.getItem("vendor-social-type");
      const authParams = this.$route.fullPath.split("?")[1];
      const apiUrl = `apps/social/${socialType}/auth?${authParams}`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "Session-Token": this.sessionToken
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            switch (resData.action) {
              case "oauth_redirect":
                window.location = resData.data.redirect_uri[0];
                break;
              case "incomplete_data":
                this.userData = {
                  accessToken: resData.data.access_token,
                  identifier: resData.data.user.identifier,
                  code: resData.data.user.code
                };
                this.appCode = resData.data.app.code;
                this.$refs.widget.view = "signup";
                this.getAppData();
                break;
              case "otp_verification":
                this.$refs.widget.view = "otp-verification";
                this.$refs.widget.setNext({
                  action: resData.action,
                  token: resData.data && resData.data.token
                });
                this.getAppData();
                break;
              default:
                break;
            }
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    getAppData() {
      const apiUrl = `apps/auth/data`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "Session-Token": this.sessionToken
            }
          }
        )
        .then(response => {
          this.appData = response.data;
          if (this.appData.status === "error") {
            this.handleErrors(this.appData);
          } else {
            this.setDomainData();
            this.setWidgetData();
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    setDomainData() {
      const { code, development } = this.appData;
      this.domainData = {
        sessionToken: this.sessionToken,
        appCode: code,
        referer: development && development.domain,
        refererRedirectUrl:
          development && development.oauth && development.oauth.redirect_uri
      };
    },

    setWidgetData() {
      const { name, customization } = this.appData;
      this.widgetData = {
        name,
        customization: customization && {
          company: customization.company_name,
          logo: customization.company_logo,
          colors: customization.meta_data && {
            primary: customization.meta_data.primary_color,
            secondary: customization.meta_data.secondary_color
          }
        },
        mfa: {
          signup: true,
          login: true
        },
        onboarding: {},
        third_party_access: [],
        schema: {
          signup: [],
          login: []
        }
      };

      this.setSchemaData();
      this.loadFieldTypes();
    },

    setSchemaData() {
      const { user_auth_types, user_data_fields } = this.appData;
      const { config } = user_auth_types && user_auth_types.password;
      const identificationFields = [
        {
          name: `user_auth_identifier_${this.labelToKey(
            config.username_label
          )}`,
          label: config.username_label,
          field_type_id: config.username_field_type_id,
          field_type: config.username_field_type,
          is_required: 1
        },
        {
          name: `user_auth_password_${this.labelToKey(config.password_label)}`,
          label: config.password_label,
          field_type_id: config.username_field_type_id,
          is_password_type: 1,
          password_validation: config.password_validation,
          field_type: {},
          is_required: 1
        }
      ];

      identificationFields.forEach(field => {
        this.widgetData.schema.signup.push(field);
        this.widgetData.schema.login.push(field);
      });

      user_data_fields.forEach(field => {
        if (!field.autofill) {
          this.widgetData.schema.signup.push(field);
        }
      });
    },

    labelToKey(label) {
      return label.toLocaleLowerCase().replace(/ /gi, "_");
    },

    loadFieldTypes() {
      fieldTypes(this.$http, this.sessionToken)
        .then(res => {
          this.fieldTypes = res;
          this.loading = false;
        })
        .catch(err => {
          this.notification("Error", err.message, "danger");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.ra-icon--eye-off::before,
.ra-icon--eye::before {
  cursor: pointer;
}
</style>
